export const desktopMenuConfig = [
  {
    id: 1,
    to: '/',
    text: 'home',
  },
  {
    id: 2,
    to: '/professional',
    text: 'professional',
  },
  {
    id: 3,
    to: '/videoGames',
    text: 'games',
  },
  {
    id: 4,
    to: '/tabletopGames',
    text: 'TTRPG',
  },
  {
    id: 5,
    to: '/workshops',
    text: 'workshops',
  },
  {
    id: 6,
    to: '/media',
    text: 'media',
  },
  {
    id: 7,
    to: '/achievements',
    text: 'achievements',
  },
];
